import React from "react";
import { Alert, Button, Grid } from "@mui/material";
import { useParams, useHistory } from "react-router-dom";
import LabeledText from "../../Widgets/LabeledText";
import { CrisisPlanFormValues } from "./interface";

interface ViewFieldsProps {
  formValues: CrisisPlanFormValues;
}

export const ViewFields: React.FC<ViewFieldsProps> = ({ formValues }) => {
  const { id: clientId } = useParams<{ id: string }>();
  const history = useHistory();
  let hasCrisisPlanText = "";
  if (formValues.hasCrisisPlan === "yes") {
    hasCrisisPlanText = "Yes";
  } else if (formValues.hasCrisisPlan === "no") {
    hasCrisisPlanText = "No";
  }

  const behaviorsIdentifiedText = formValues.behaviorsIdentified
    .map((b) =>
      b
        .replaceAll("_", " ")
        .toLowerCase()
        .replace(/^\w/, (c) => c.toUpperCase())
    )
    .join(", ");

  return (
    <Grid container sx={{ rowGap: "24px" }}>
      <LabeledText label="Does the client need a crisis plan?" value={hasCrisisPlanText} />

      <LabeledText label="Crisis plan" value={formValues.crisisPlan} />

      <LabeledText label="Behaviors identified" value={behaviorsIdentifiedText} />

      <Grid item xs={12}>
        <Alert
          severity="info"
          action={
            <Button
              color="info"
              size="small"
              variant="text"
              onClick={() => history.push(`/clients/${clientId}/strengths-and-areas-of-need`)}
            >
              View Safety Concerns
            </Button>
          }
        >
          These behaviors are based on the safety concerns documented in the client&apos;s profile.
        </Alert>
      </Grid>

      <LabeledText label="Additional considerations" value={formValues.additionalConsiderations} />
    </Grid>
  );
};

export default ViewFields;
